import React from 'react'
import { Text, View } from 'oio-react'
import PropTypes from 'prop-types'
import MoreIcon from 'assets/icons/more'

const UserListItem = ({
   avatarMedia,
   borderTop,
   fullName,
   onOptionsButtonClick,
   organization,
   position,
   status
}) => {
   const avatarUrl = avatarMedia
      ? avatarMedia?.file.thumbnailUrlW48
      : '/assets/images/avatarPlaceholder.svg'

   return (
      <View
         display="flex"
         alignItems="center"
         float="left"
         width="100%"
         padding="9px 0px"
         borderTop={borderTop}>
         <View
            flex="0 0 auto"
            width="24px"
            height="24px"
            borderRadius="3px"
            backgroundColor="#ddd"
            backgroundImage={`url(${avatarUrl})`}
            backgroundSize={avatarMedia ? 'cover' : '21px 21px'}
            backgroundPosition="bottom center"
            style={{
               backgroundRepeat: 'no-repeat'
            }}
         />
         <View flex="1 1 auto" padding="0 18px">
            <Text size="2" color="#333" weight="medium">
               {fullName}
            </Text>
            <Text size="2" color="#aaa" weight="normal">
               {position}
               {organization}
            </Text>
         </View>
         <View flex="0 0 auto">
            {['active', 'invited'].includes(status) && (
               <View
                  position="relative"
                  onClick={onOptionsButtonClick}>
                  <MoreIcon
                     width="24px"
                     height="24px"
                     color="#aaa"
                  />
               </View>
            )}
         </View>
      </View>
   )
}

UserListItem.propTypes = {
   avatarMedia: PropTypes.object,
   borderTop: PropTypes.string,
   fullName: PropTypes.string.isRequired,
   onOptionsButtonClick: PropTypes.func.isRequired,
   organization: PropTypes.string,
   position: PropTypes.string,
   status: PropTypes.string.isRequired
}

UserListItem.defaultProps = {
   avatarMedia: undefined,
   borderTop: '1px solid #eee',
   organization: undefined,
   position: undefined
}

export default React.memo(UserListItem)
